// =======================
// 🔹 REGISTER PLUGIN
// =======================
gsap.registerPlugin(ScrollTrigger);

// =======================
// 🔹 HERO SECTION ANIMATION
// =======================
const heroTL = gsap.timeline({
  scrollTrigger: {
    trigger: ".hero",
    start: "top top",
    end: "bottom top",
    scrub: true,
    pin: true,
 
  }
});

heroTL
  .to(".hero .bg", {
    scale: 2.5,
    opacity: 0,
    ease: "none"
  })
  .fromTo(".hero .content", 
    { opacity: 1, y: -10 },
    { opacity: 1, y: 80, ease: "none" },
    "<" // runs together with bg animation
  );

